import { Fragment } from 'react';
import { IProductDelivery, IShipmentData } from 'types/orders';
import ShipmentProductRow from '../ShipmentProductRow';

interface IShipmentProductsBlockProps {
  shipmentData: IShipmentData | null;
  shipmentIndex: number;
  shipmentId: number;
  showShipmentLabel: boolean;
  onRetry: () => void;
  onOpenSerialsModal: (
    product: IProductDelivery,
    productsFromShipment: IProductDelivery[],
    shipmentIndex: number
  ) => void;
}

const ShipmentProductsBlock = ({
  shipmentData,
  shipmentIndex,
  shipmentId,
  showShipmentLabel,
  onRetry,
  onOpenSerialsModal
}: IShipmentProductsBlockProps) => {
  const isError = !shipmentData;

  if (isError) {
    return (
      <div className="shipmentProductsBlock errorState" data-testid={`shipment-error-${shipmentId}`}>
        <span>Error al cargar productos del envío {shipmentIndex + 1}</span>
        <button className="retryButton" type="button" onClick={onRetry}>
          Reintentar
        </button>
      </div>
    );
  }

  const products = shipmentData.products ?? [];

  return (
    <div
      className="shipmentProductsBlock"
      key={`shipment-products-${shipmentId}`}
      data-testid={`shipment-products-${shipmentId}`}
    >
      {showShipmentLabel && (
        <span className="shipmentProductsLabel">Envío {shipmentIndex + 1}</span>
      )}
      <div className="productsSection">
        {products.length > 0 ? (
          products.map((product, productIndex) => (
            <Fragment key={`product-${shipmentId}-${product.id}-${productIndex}`}>
              <ShipmentProductRow
                product={product}
                productNumber={productIndex + 1}
                totalProducts={products.length}
                status={shipmentData.status}
                statusId={shipmentData.statusId}
                trackingInfo={shipmentData.trackingInfo}
                warehouseTemporaryStorage={shipmentData.warehouseTemporaryStorage}
                onSerialClick={() => onOpenSerialsModal(product, products, shipmentIndex)}
              />
              {productIndex < products.length - 1 && <div className="divider" />}
            </Fragment>
          ))
        ) : (
          <div className="noProducts">No hay productos en este envío</div>
        )}
      </div>
    </div>
  );
};

export default ShipmentProductsBlock;
